<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <el-form
            :model="formData"
            style="margin-left: 20px;"
            label-width="140px"
            label-position="left"
            size="mini"
          >
            <!-- 基本信息 -->
            <el-form-item label="客户名称" prop="groupName">
              <p>{{formData.groupName}}</p>
            </el-form-item>
            <el-form-item
              label="客户地址"
              prop="groupAddress"
            >{{`${formData.provinceName}-${formData.cityName}-${formData.areaName}`}}</el-form-item>
            <el-form-item label="详细地址" prop="address">{{formData.address}}</el-form-item>
            <el-form-item label="联系人姓名" prop="personName">{{formData.personName}}</el-form-item>
            <el-form-item label="联系人手机号" prop="personPhone">{{formData.personPhone}}</el-form-item>
            <el-form-item label="客户类型" prop="groupTypeCode">{{formData.groupTypeName}}</el-form-item>
<!--            <el-form-item label="营业执照" prop="licensePic">-->
<!--              <img-upload-->
<!--                  disabled-->
<!--                  :fileList="formData.licensePic"-->
<!--                  @getFileList="(val)=> fileList=val"-->
<!--              ></img-upload>-->
<!--            </el-form-item>-->
            <el-form-item label="营业执照" prop="licensePic">
              <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                <div v-for="(item, index) in formData.licenseList" :key="index">
                  <el-image
                      :src="item.licensePic"
                      style="width: 200px; height: 150px; object-fit: cover; border: 1px solid #ddd;"
                      :preview-src-list="[item.licensePic]"
                      :initial-index="0"
                      :show-preview="true"
                  ></el-image>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="formData.accountType=== 2" label="门店数量上限" prop="storeNumLimit">{{formData.storeNumLimit}}个</el-form-item>
            <div v-if="formData.accountType!==1">
              <el-form-item label="合同有效期">{{`${formData.contractStart} - ${formData.contractEnd}`}}</el-form-item>
              <el-form-item label="合同状态">{{formData.contractStatus}}</el-form-item>
            </div>
            <el-form-item label="美菜合作主体" prop="contractSubjectName">{{ formData.contractSubjectName }}</el-form-item>
            <el-form-item label="支持冷链" prop="supportColdChain">
              <el-radio disabled v-model="formData.supportColdChain" :label="0">否</el-radio>
              <el-radio disabled v-model="formData.supportColdChain" :label="1">是</el-radio>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="结算信息" name="second">
          <el-form
            :model="formData"
            style="margin-left: 20px;"
            label-width="140px"
            label-position="left"
            size="mini"
          >
            <div v-if="formData.accountType=== 2">
              <el-form-item label="账期承担方" prop="financeGroupId">{{formData.financeGroupName}}</el-form-item>
              <el-form-item label="送货周期" prop="settleCycleType">{{formData.settleCycleTypeName}}</el-form-item>
              <el-form-item label="账期限额" prop="afterPayLimit">{{formData.afterPayLimit}} 元</el-form-item>
              <el-form-item label="对账时限" prop="checkCycleDays">{{formData.checkCycleDays}} 天</el-form-item>
              <el-form-item label="开票时限" prop="invoiceCycleDays">{{formData.invoiceCycleDays}} 天</el-form-item>
              <el-form-item label="回款时限" prop="backMoneyCycleDays">{{formData.backMoneyCycleDays}} 天</el-form-item>
              <el-form-item label="账期天数" prop="dayCount">{{formData.dayCount}} 天</el-form-item>
              <el-form-item label="示意图">
                <img src="../../../assets/images/time.png" alt="">
              </el-form-item>
            </div>
            <el-form-item
              v-if="formData.accountType!==2"
              label="结算方式"
              prop="payWay"
            >{{formData.payWayName}}</el-form-item>
            <el-form-item
              v-if="formData.accountType!==2"
              label="开票天数"
              prop="invoiceDelay"
            >{{formData.invoiceDelay}} 天</el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="账号信息" name="third">
          <el-form
            :model="formData"
            style="margin-left: 20px;"
            label-width="140px"
            label-position="left"
            size="mini"
          >
            <el-form-item label="客户ID">{{formData.groupId}}</el-form-item>
            <el-form-item label="绑定手机号">{{formData.phone}}</el-form-item>
            <el-form-item label="审核状态">{{formData.verifyStatus}}</el-form-item>
            <el-form-item label="启用状态">{{formData.status}}</el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="业务经理" name="fourth">
          <el-form
            :model="formData"
            style="margin-left: 20px;"
            label-width="140px"
            label-position="left"
            size="mini"
          >
            <el-form-item label="销售经理">{{`${formData.saleName}-${formData.saleRole}`}}</el-form-item>
          </el-form>
          <p style="color: red">注：有任何问题请联系业务经理</p>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      formData: {},
      saleCodesLoading: false,
      saleCodes: [],
      fileList: [],
      value: [],
      clientTypes: []
    };
  },
  created() {
    this.getGroupInfo();
  },
  methods: {
    async getGroupInfo() {
      const {
        ret,
        data: { detail }
      } = await _api.customer.getGroupInfo({
        groupId: this.$route.query.groupId
      });
      if (ret && detail) {
        const { provinceId, cityId, areaId, groupId } = detail;
        this.$set(this, "formData", detail);
        this.value = [provinceId, cityId, areaId];
        const _ENV_ = this.$store.getters.userInfo;

        // if (!this.$cookies.isKey("purchaseGroupId")) {
        this.$cookies.set('purchaseGroupId', groupId, false, '/', '.yunshanmeicai.com', false);
        this.$cookies.set('DMALL_USER_TOKEN', _ENV_.tickets, false, '/', '.yunshanmeicai.com', false);
        // }
      }
    },
    getFileList(fileList) {
      this.fileList = fileList;
    },
    handleBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.title {
  font-weight: 900;
  font-size: 18px;
}
.el-input {
  width: 300px;
}
.marginRight10 {
  margin-right: 10px;
}
</style>
